import React, { Component } from "react";
import { bool, string, func } from 'prop-types';
import Header from "Orgs/Header";
import PageHeader from "Molecules/PageHeader";
import LoginForm from './children/LoginForm';
import SupportInfo from "Molecules/SupportInfo";
import Footer from "Orgs/Footer";
import TermsOfUseFooter from "Orgs/TermsOfUseFooter";
import { digitalData } from "../../../../utils/analyticsData";
import "react-client-captcha/dist/index.css";
import Crypto from "crypto-js/enc-utf8.js";
import base64encrypt from "crypto-js/enc-base64.js";


let CAPTCHA;
let MAINTENANCE_MODE;


if (sessionStorage.getItem('app_info')) {
	CAPTCHA = JSON.parse(sessionStorage.getItem('app_info')).CAPTCHA;
} else {
	CAPTCHA = "YES"
}




export default class LoginPage extends Component {


	constructor(props) {
		super(props)
		this.testVarible = "false";
		this.captchaLoadtime = null;
		this.state = {
			error: false,
			message: "",
			loginInfo: false,
			supportInfo: false,
			mobileView: false,
			verifyCaptcha: false
		}
	}

// NEW: same format you already use (UTC HH:mm:ss.SSS)
getUtcTimeStamp = () => {    const d = new Date();    return this.addZero(d.getUTCHours(), 2) + ":" +           this.addZero(d.getUTCMinutes(), 2) + ":" +           this.addZero(d.getUTCSeconds(), 2) + "." +           this.addZero(d.getUTCMilliseconds(), 3);} 
// NEW: called every time a captcha is generated/refreshed
handleCaptchaLoad = () => {    this.captchaLoadTime = this.getUtcTimeStamp();}

	componentWillMount() {

		this.removeSessionStorage()

		if (!window.console) { window.console = {}; window.console.log = function () { } };
		//clear redux store if not cleared already
		this.props.resetStore();
		this.props.hidePayVeil();
		this.props.hidePayModal();
	}

	closeInfoBox = () => {
		this.setState({
			...this.state,
			supportInfo: false
		});
	}


	componentDidMount() {
		try {
			if(sessionStorage.getItem('app_info')){
				MAINTENANCE_MODE=JSON.parse(sessionStorage.getItem('app_info')).MAINTENANCE_MODE;
				if( MAINTENANCE_MODE === true){
					window.location.href = "/maintenance";
				}
			}
			const title = document.getElementsByTagName('title')[0];
			title.textContent = "PCS Express Billing Payment";
			global.digitalData = digitalData;
			window.addEventListener("resize", () => {
				if (window.innerWidth < 760) {
					this.closeInfoBox();
				}
			});
		} catch (err) { }

	}

	removeSessionStorage = () => {
		localStorage.removeItem('recieptInfo');
	}


	errorMessagesHandler = (accountInfoCreds, accountNumber, zip) => {

		if ((typeof accountInfoCreds !== "object") || (accountNumber.length < 14 && zip.length < 5)) {
			this.setState({
				error: true,
				message: "Something seems amiss with both of these entries. Please take a look at each field, and try again, thanks!"
			})
		} else if (accountNumber.length < 14 && zip.length === 5) {
			this.setState({
				error: true,
				message: "Sorry, this Billing Account Number is invalid. Please input a 13-digit number."
			})
		} else if (accountNumber.length === 14 && zip.length < 5) {
			this.setState({
				error: true,
				message: "Sorry, this U.S. Billing Zip Code doesn’t seem to be working."
			})
		}
	}
	base64Encrypt = (data) => {
		let encryptedUCode = '';
		var wordArrayUCode = Crypto.parse(data);
	    encryptedUCode = base64encrypt.stringify(wordArrayUCode);
		return encryptedUCode;
	}
	addZero = (x, n) => {
		while (x.toString().length < n) {
			x = "0" + x;
		}
		return x;
	}
	submitHandler = (accountInfoCreds) => {
		let { accountNumber, zip, cCode , timeStamp } = accountInfoCreds;
		console.log("Sending timeStamp:", timeStamp, "Now:", new Date().toISOString());

		let uCode = '';
		let encryptedUCode = '';
		
		if (CAPTCHA === "YES") {
			try {
				uCode = document.getElementById('user_captcha_input').value;
				encryptedUCode = this.base64Encrypt(uCode);
			} catch (err) {
				uCode = ''
			}
		}
		if (accountInfoCreds.accountNumber !== undefined) {

			if (accountInfoCreds.accountNumber && accountInfoCreds.zip && accountInfoCreds.accountNumber.length === 14 && accountInfoCreds.zip.length === 5) {
				if (CAPTCHA === "NO") {
					this.props.loadAccounts(accountInfoCreds.accountNumber, accountInfoCreds.zip, this.props.history);
				}
				else if (uCode === '') {
					this.setState({
						error: true,
						message: "Please provide captcha to continue!"
					})
				}
				else {
					this.getBillingDetailsWithCaptchaCallHappens(cCode, accountInfoCreds, encryptedUCode, timeStamp);
				}

			} else {

				this.errorMessagesHandler(accountInfoCreds, accountNumber, zip);

			}

		}

	};



	getBillingDetailsWithCaptchaCallHappens(cCode, accountInfoCreds, encryptedUCode, timeStamp) {
		if (cCode !== null) {
			this.props.loadAccounts(accountInfoCreds.accountNumber, accountInfoCreds.zip, cCode, encryptedUCode, timeStamp, this.props.history);
		}
		else {
			this.setState({
				error: true,
				message: "You have entered incorrect captcha! Please try again!!"
			});
			document.getElementById('user_captcha_input').value = "";
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.accountsInfo.error) {
			this.setState({
				error: nextProps.accountsInfo.error,
				message: nextProps.accountsInfo.errorInfo.message
			})
			global.digitalData.page.error[0] = nextProps.accountsInfo.errorInfo.message
		}
	}

	toggleSupportInfo = () => {
		let si = !this.state.supportInfo;
		this.setState({
			...this.state,
			loginInfo: false,
			supportInfo: si
		});
	}
	toggleLoginInfo = () => {
		let li = !this.state.loginInfo;
		this.setState({
			...this.state,
			loginInfo: li,
			supportInfo: false,
		});
	}

	render() {
		let { error, message } = this.state;

		return (
			<div className="LoginPage">
				<div className="login-main">
					<Header toggleBox={this.toggleSupportInfo} closeBox={this.closeInfoBox} />
					{this.state.supportInfo && <div aria-modal="true" className="infoBox support-info-is-visible">
						<SupportInfo closeBox={this.toggleSupportInfo} />
					</div>}
					<div className="site-main">
												<div className="limeLogo"  tabIndex="0">
									<img src="/media/icons/PCS_brandmark_Lime.png" width={150} alt="PCS Brandmark" />
									
							</div>
						<PageHeader
						
							subtitle="Let's find your account."
						/>
						<main>
							<LoginForm
								loginInfo={this.state.loginInfo}
								toggleBox={this.toggleLoginInfo}
								error={error}
								errorMessage={message}
								submitHandler={this.submitHandler}
								billingAccountLength={14}
								zipCodeLength={5}
								onCaptchaLoad={this.handleCaptchaLoad}

							/>
						</main>
					</div>
					<Footer mobile={true} />
				</div>
				<TermsOfUseFooter />

				{window.innerWidth < 760 && <div className="infoBox support-info-is-hidden">
					<SupportInfo mobile={true} />
				</div>}
				<div id="sdsfd" />
			</div>
		);
	}
}

LoginPage.propTypes = {
	error: bool,
	message: string,
	submitHandler: func
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/LoginPage/LoginPage.js